import React from "react";
import SEO from "../../components/SEO/SEO";
import HeroSection from "./sections/HeroSection";
import ServicesSection from "./sections/ServicesSection";
import HowItWorksSection from "./sections/HowItWorksSection";
import FleetSection from "./sections/FleetSection";
import AirportsSection from "./sections/AirportsSection";
import RoutesSection from "./sections/RoutesSection";
import BookingSection from "./sections/BookingSection";
import WhySection from "./sections/WhySection";
import AboutSection from "./sections/AboutSection";
import FaqSection, { homeFaqs } from "./sections/FaqSection";

export default function Home(): JSX.Element {
  return (
    <>
      <SEO
        canonical="/"
        title="Limo & Black Car Service Glassboro NJ | GS Limo Elite"
        description="Chauffeur-driven limo and black car service in Glassboro, NJ. Airport transfers to PHL, EWR and JFK for South Jersey, Philadelphia and NY. Call (929) 452-6031."
        faq={homeFaqs}
        includeWebsite
      />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <HowItWorksSection />
      <FleetSection />
      <AirportsSection />
      <RoutesSection />
      <WhySection />
      <FaqSection />
      <BookingSection />
    </>
  );
}


